//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('subOperations', {
//        templateUrl: 'views/components/views/subOperations/subOperations.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'subOperationsService', 'ttGridFactory', function ($stateParams, stateService, utilityService, subOperationsService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let operationId = $stateParams.operation_id;

//            vm.model = {
//                setting: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setCustomToolbarButtons([{
//                name: 'suboperations_new',
//                text: 'suboperations_new',
//                func: () => {
//                    stateService.go('suboperation', {
//                        operation_id: vm.model.setting.operation_id,
//                        suboperation_keyno: '0'
//                    });
//                },
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true,
//                disabled: function () { return; }
//            }]);
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await subOperationsService.getSubOperations({ operation_id: operationId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) !== true) return;

//                vm.grid.dataTask.loadData = {
//                    method: vm.model.setting.p2_datatask_keyno,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
